export default {
    init() {
        // JavaScript to be fired on single post templates
        function hideSocialShare() {
            const $singleMain = $('.single__main');
            const $socialSharing = $('.social-sharing');
            const $singleMainOffset = $singleMain.offset();
            const trigger =
            $singleMainOffset.top +
                $singleMain.outerHeight() +
                ($(window).height() / 2);
            const scrollPosition = $(document).scrollTop() + $(window).height();

            if (scrollPosition >= trigger) {
                $socialSharing.css({opacity: 0, visibility: 'hidden'})
            } else {
                $socialSharing.css({opacity: 1, visibility: 'visible'})
            }
        }

        $(window).scroll(hideSocialShare);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-post.js